import { makeStyles, tokens } from '@fluentui/react-components';

export const useStaticMessageStyles = makeStyles({
  startOver: {
    fontWeight: tokens.fontWeightRegular,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    position: 'absolute',
    top: tokens.spacingVerticalXS,
    paddingTop: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalXXS,
    paddingRight: tokens.spacingHorizontalS,
    paddingLeft: tokens.spacingHorizontalS,
    zIndex: 1,
  },
  staticPrimary: {
    display: 'flex',
    marginTop: tokens.spacingVerticalM,
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  root: {
    '&.ResponsibleAI .start-over-btn': {
      position: 'static',
      marginTop: tokens.spacingVerticalXS,
    },
  },
});
